import React from 'react';
import ThumbIconUp from './ThumbIconUp';
import ThumbIconDown from './ThumbIconDown';
import { ThumbDownStyled, ThumbUpStyled } from './FeedbackIcon.styles';

const FeedbackIcon = () => {
    return (
        <>
            <ThumbUpStyled><ThumbIconUp /></ThumbUpStyled>
            <ThumbDownStyled><ThumbIconDown /></ThumbDownStyled>
        </>
    );
};

export default FeedbackIcon;
